import React, { useEffect, useState } from "react";
import { X, ShareNetwork, Plus } from "@phosphor-icons/react";

export default function InstallPrompt() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const dismissed = localStorage.getItem("wp_install_dismissed");
    if (dismissed) return;
    const ua = window.navigator.userAgent;
    const isIOS = /iphone|ipad|ipod/i.test(ua);
    const isStandalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (isIOS && !isStandalone) {
      setTimeout(() => setShow(true), 4000);
    }
  }, []);

  const dismiss = () => {
    localStorage.setItem("wp_install_dismissed", "1");
    setShow(false);
  };

  if (!show) return null;
  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:max-w-sm z-50 bg-[#7F7164] border border-[#D4A574]/40 p-4" data-testid="install-prompt">
      <button onClick={dismiss} className="absolute top-2 right-2 text-zinc-500 hover:text-white" data-testid="install-prompt-close">
        <X size={16} />
      </button>
      <div className="label-overline text-[#D4A574]">// Add to your home screen</div>
      <p className="text-sm text-zinc-200 mt-2 leading-relaxed">
        Get the full app experience. Tap <ShareNetwork weight="bold" size={14} className="inline mx-1 -mt-0.5" /> in Safari, then <span className="font-bold">"Add to Home Screen"</span> <Plus weight="bold" size={14} className="inline ml-1 -mt-0.5" />.
      </p>
    </div>
  );
}
